import { db } from '../firebaseConfig';
import { collection, addDoc } from 'firebase/firestore';

/**
 * Transactional Email Service for GymGhost (contact@gymghost.net)
 * Handles sending formatted notifications to coaches and trainees.
 * Integrates directly with Firestore 'mail' collection (Firebase Trigger Email extension)
 * with graceful fallback log execution.
 */

export const sendNewTraineeNotification = async ({ trainerEmail, traineeName, traineeEmail }) => {
  if (!trainerEmail) return;

  const subject = `🏋️ Nowy zawodnik połączył się z Twoim kontem Trenera w GymGhost!`;
  const html = `
    <div style="font-family: Arial, sans-serif; background-color: #0a101d; color: #f1f5f9; padding: 24px; border-radius: 16px;">
      <div style="text-align: center; margin-bottom: 20px;">
        <h1 style="color: #10b981; margin: 0; font-size: 24px;">GymGhost</h1>
        <p style="color: #94a3b8; font-size: 14px; margin-top: 4px;">Platforma dla Trenerów i Zawodników</p>
      </div>

      <div style="background-color: #0f172a; border: 1px solid #1e293b; padding: 20px; border-radius: 12px;">
        <h2 style="color: #ffffff; font-size: 18px; margin-top: 0;">Cześć!</h2>
        <p style="color: #cbd5e1; font-size: 14px; line-height: 1.6;">
          Zawodnik <strong>${traineeName || traineeEmail}</strong> (<code>${traineeEmail}</code>) właśnie wpisał Twój Kod Trenera i połączył się z Twoim kontem w GymGhost!
        </p>

        <div style="margin: 20px 0; padding: 12px; background-color: #064e3b; border-radius: 8px; color: #6ee7b7; font-weight: bold; text-align: center;">
          ✅ Możesz już przypisywać mu plany i śledzić treningi na żywo.
        </div>

        <div style="text-align: center; margin-top: 24px;">
          <a href="https://app.gymghost.net" style="background-color: #10b981; color: #022c22; text-decoration: none; font-weight: bold; padding: 12px 24px; border-radius: 8px; display: inline-block;">
            Otwórz Portal Trenera ➔
          </a>
        </div>
      </div>

      <div style="text-align: center; margin-top: 20px; color: #64748b; font-size: 12px;">
        Wysłano automatycznie przez GymGhost (contact@gymghost.net)
      </div>
    </div>
  `;

  try {
    await addDoc(collection(db, 'mail'), {
      to: [trainerEmail],
      message: {
        subject,
        html,
        from: 'GymGhost <contact@gymghost.net>'
      },
      createdAt: Date.now()
    }).catch(() => {});
  } catch (err) {
    console.warn("Mail queue notice:", err.message);
  }
};

export const sendNewPlanAssignedNotification = async ({ traineeEmail, planTitle, trainerName }) => {
  if (!traineeEmail) return;

  const subject = `🔥 Nowy Plan Treningowy: ${planTitle || 'GymGhost Routine'} od Twojego Trenera!`;
  const html = `
    <div style="font-family: Arial, sans-serif; background-color: #0a101d; color: #f1f5f9; padding: 24px; border-radius: 16px;">
      <div style="text-align: center; margin-bottom: 20px;">
        <h1 style="color: #10b981; margin: 0; font-size: 24px;">GymGhost</h1>
        <p style="color: #94a3b8; font-size: 14px; margin-top: 4px;">Twój Dziennik Treningowy</p>
      </div>

      <div style="background-color: #0f172a; border: 1px solid #1e293b; padding: 20px; border-radius: 12px;">
        <h2 style="color: #ffffff; font-size: 18px; margin-top: 0;">Gotowy na trening?</h2>
        <p style="color: #cbd5e1; font-size: 14px; line-height: 1.6;">
          Twój Trener <strong>${trainerName || 'Trener'}</strong> przypisał Ci nowy plan treningowy:
        </p>

        <div style="margin: 16px 0; padding: 16px; background-color: #1e293b; border-left: 4px solid #10b981; border-radius: 6px;">
          <h3 style="color: #10b981; margin: 0; font-size: 16px;">${planTitle || 'Nowy Plan Treningowy'}</h3>
        </div>

        <div style="text-align: center; margin-top: 24px;">
          <a href="https://app.gymghost.net" style="background-color: #10b981; color: #022c22; text-decoration: none; font-weight: bold; padding: 12px 24px; border-radius: 8px; display: inline-block;">
            Rozpocznij Trening w Aplikacji ➔
          </a>
        </div>
      </div>

      <div style="text-align: center; margin-top: 20px; color: #64748b; font-size: 12px;">
        Wysłano automatycznie przez GymGhost (contact@gymghost.net)
      </div>
    </div>
  `;

  try {
    await addDoc(collection(db, 'mail'), {
      to: [traineeEmail],
      message: {
        subject,
        html,
        from: 'GymGhost <contact@gymghost.net>'
      },
      createdAt: Date.now()
    }).catch(() => {});
  } catch (err) {
    console.warn("Mail queue notice:", err.message);
  }
};

export const sendPasswordResetNotification = async ({ userEmail }) => {
  if (!userEmail) return;

  const subject = `🔒 Resetowanie Hasła Konta w GymGhost`;

  try {
    await addDoc(collection(db, 'mail'), {
      to: [userEmail],
      type: 'PASSWORD_RESET',
      isPasswordReset: true,
      message: {
        subject,
        from: 'GymGhost <contact@gymghost.net>'
      },
      createdAt: Date.now()
    }).catch((err) => console.warn("Firestore mail add error:", err.message));
  } catch (err) {
    console.warn("Mail queue notice:", err.message);
  }
};
